<template>
  <div class="bo-import-logs">
    <p v-for="(l, k) in all"
       :class="`text-${l.type}`"
       :key="k">
      {{ l.text }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'bo-import-logs',
  props: {
    logs: Array
  },
  data () {
    return {
      all: this.logs
    }
  },
  watch: {
    logs (value) {
      this.all = value
    }
  }
}
</script>
<style scoped lang="less">
.bo-import-logs {
    height: 20rem;
    overflow-y: scroll;
}
</style>
